<template>
    <div class="table-list ledger-mgt-table">
        <modal class="delete-bill" :display="modalStatus.deleteLedger" @modalStatus="closeAlarmModal" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>刪除記帳</h1>
            <div class="content">
                確定刪除 ”{{ledgerName}}”的記帳嗎？記錄確認刪除將無法回復
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteLedger(), $analyticsBiz.logEvent('刪除記帳本', { screen_name: '刪除記帳本'})">確認</button>
                <button class="border-button" @click="closeAlarmModal">取消</button>
            </div>
        </modal>
        <ledger-detail :ledgerItem="filterByWord[selected]"></ledger-detail>
        <!-- <edit-ledger :key="componentKey" :ledgerDetail="filterByWord[selected]"></edit-ledger> -->
        <div class="mask"></div>
        <div class="table-list-title">
            <span class="date">記帳時間</span>
            <span class="house-wrap">地址或房源群組名稱</span>
            <span class="income">記帳類別</span>
            <span class="source">記帳項目</span>
            <span class="note">備註</span>
            <span class="agent">業務</span>
            <span class="amount">金額</span>
            <span class="action">操作</span>
        </div>
        <div class="table-list-body">
            <div v-if="isLoading" class="filter-empty">
                <table-loading />
            </div>
            <div v-else-if="filterByWord.length == 0 && ledgerMgtList.length != 0" class="filter-empty">
                <span>0 個搜尋結果</span>
                <button class="default-button" @click="setFilterDefault">清除篩選</button>
            </div>
            <div v-else-if="ledgerMgtList.length == 0" class="is-empty">0 筆資料</div>
            <ul v-else>
                <li v-for="(list,index) in filterByWord" :key="index">
                    <span class="date">{{getFormatDate(list.recordingDate)}}</span>
                    <div class="house-wrap">
                        <span class="house-group" v-if="list.isHouseGroup">
                            群
                        </span>
                        <span class="house">
                            {{list.name}}
                            <!-- {{list.name.length >= 15?compressWord(list.name, 15):list.name}}
                            <div v-if="list.name.length >= 15" class="full-word">
                                <span>
                                    {{list.name}}
                                </span>
                            </div> -->
                        </span>
                        
                    </div>
                    <span class="income body blue" v-if="list.ledgerType == 'INCOME'">{{transType(list.ledgerType)}}</span>
                    <span class="income body gray" v-if="list.ledgerType == 'ADVANCE_PAYMENT'">{{transType(list.ledgerType)}}</span>
                    <span class="income body red" v-if="list.ledgerType == 'EXPENSE'">{{transType(list.ledgerType)}}</span>
                    <span class="source">{{list.ledgerItemType !== 'DEPOSIT'?ledgerItemType(list.ledgerItemType):list.ledgerType === 'EXPENSE'?'退房客押金':ledgerItemType(list.ledgerItemType)}}</span>
                    <span class="note">{{list.ledgerItemName}}</span>
                    <span class="agent">{{list.agentName}}</span>
                    <span class="amount">
                        {{listAmount(list)}}
                        <ledger-tips-hover v-if="list.ledgerType == 'ADVANCE_PAYMENT'" :data="{amount: list.amount, quote: list.quote}"></ledger-tips-hover>
                    </span>
                    <span class="action">
                        <dot-dropmenu>
                            <ul >
                                <li @click="editLedger(list), $analyticsBiz.logEvent('編輯記帳', { screen_name: '編輯記帳'})"
                                    v-if="bizAuth.editLedger.hasRight">編輯</li>
                                <li @click="viewDetail(index), $analyticsBiz.logEvent('查看明細', { screen_name: '查看明細'})"
                                    v-if="bizAuth.viewLedger.hasRight">查看明細</li>
                                <li @click="ledgerName = list.name, ledgerId = list.ledgerId, openAlarmModal()"
                                v-if="bizAuth.deleteLedger.hasRight">刪除</li>
                            </ul>
                        </dot-dropmenu>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import DotDropMenu from '@/components/widge/DotDropMenu.vue';
import Modal from '@/components/widge/Modal.vue';
import ledgerDetail from '@/components/bussiness/widges/modals/ledgerDetail.vue';
import ledgerTipsHover from '@/components/bussiness/widges/tips/ledgerTipsHover.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { 
    deleteLedger
    } from "@/apis/company/ledger.js"; 


import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            componentKey: 0,
            selected: 0,
            selectedAddress: null,
            ledgerId: null,
            ledgerName: null,
            modalStatus: {
                deleteLedger: false
            },
            status: {
                addressShow: true
            }
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            default: true
        },
    },
    mounted () {
        this.$analyticsBiz.logEvent("記帳本", {
            screen_name: "記帳本"
        });
    },
    watch: {
        filterByWord:{
            handler: function (val) {
                this.$store.dispatch('setBizLedgerMgtFilterResult',  val)
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setBizLedgerMgtFilterDefault')
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        editLedger: function (ledger) {
            // this.$store.dispatch('setBizEditLedger', ledger)
            this.$router.push({name: 'bizEditLedger', query: {id: ledger.ledgerId}})
        },
        openAlarmModal: function () {
            this.modalStatus.deleteLedger = true
            this.$store.commit('modalStatus/set_modal_mode', true)
        },
        closeAlarmModal: function () {
            this.$store.commit('modalStatus/set_modal_mode', false)
            this.modalStatus.deleteLedger = false
        },
        viewDetail: function (index) {
            this.selected = index
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizLedgerDetail'})
        },
        deleteLedger: function () {
            let data = {
                ledgerId: this.ledgerId
            }
            deleteLedger(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let hashTag = decodeURIComponent(this.$route.hash)

                    if( hashTag == '#今日' ){
                        this.$store.dispatch('getBizLedgerMgtList', 'DAY')
                    }else if( hashTag == '#近七天' ){
                        this.$store.dispatch('getBizLedgerMgtList', 'WEEK')
                    }else if( hashTag == '#近一個月' ){
                        this.$store.dispatch('getBizLedgerMgtList', 'MONTH')
                    }else if( hashTag == '#本季' ){
                        this.$store.dispatch('getBizLedgerMgtList', 'SEASON')
                    }else if( hashTag == '#今年' ){
                        this.$store.dispatch('getBizLedgerMgtList', 'YEAR')
                    }else{
                        this.$store.dispatch('getBizLedgerMgtList', 'YEAR')
                    }
                    this.closeAlarmModal()
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '成功刪除記帳',type: 'success'})

                    // console.log(res)
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        listAmount: function (list) {
            if(list.ledgerType == 'ADVANCE_PAYMENT'){
                let isPositive = this.isPositive(list.quote-list.amount)
                let amount = this.toCurrency(Math.abs(list.quote-list.amount))
                if(isPositive){
                    return amount
                }else{
                    return '- '+amount
                }
            }else if(list.ledgerType == 'INCOME'){
                return this.toCurrency(list.amount)
            }else if(list.ledgerType == 'EXPENSE'){
                return '- '+this.toCurrency(list.amount)
            }
        },
        isPositive: function (value) {
            if(value){
                let result = Math.sign(value)
                if( result == 1 || result == 0){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        }
    },
    computed: {
        filterByCounty: function () {
            return this.ledgerMgtList.filter((item) => {
                if(this.filterQuery.county){
                    if(item.name.includes(this.filterQuery.county) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByDistrict: function () {
            return this.filterByCounty.filter((item) => {
                if( this.filterQuery.district){
                    if(item.name.includes(this.filterQuery.district) == true){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        // filterByAmount: function () {
        //     return this.filterByDistrict.filter((item) => {
        //         if( this.filterQuery.amount ){
        //             if( this.filterQuery.amount[0] <= item.amount && this.filterQuery.amount[1] >= item.amount ){
        //                 return item
        //             }
        //         }else{
        //             return item
        //         }
        //     });
        // },
        filterByDate: function () {
            return this.filterByDistrict.filter((item) => {
                // console.log(item)
                if( this.filterQuery.date[0] && this.filterQuery.date[1] ){
                    let ledger = item.recordingDate,
                        filterLedgerStart = Date.parse(this.filterQuery.date[0]).valueOf()+28800000,
                        filterLedgerEnd = Date.parse(this.filterQuery.date[1]).valueOf()+28800000
                    if( filterLedgerStart <= ledger && ledger <= filterLedgerEnd ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByGroup: function () {
            return this.filterByDate.filter((item) => {
                if(this.filterQuery.group){
                    if(item.groupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.agentName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByType: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.type){
                    if(item.ledgerType == this.filterQuery.type ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByItem: function () {
            return this.filterByType.filter((item) => {
                if(this.filterQuery.item){
                    if(item.ledgerItemType == this.filterQuery.item ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByWord: function () {
            return this.filterByItem.filter((item) => {
                if( this.filterWord ){
                    if( item.name.includes(this.filterWord)){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            ledgerMgtList: 'GET_BIZ_LEDGER_MGT_LIST',
            filterQuery: 'GET_BIZ_LEDGER_MGT_FILTER_QUERY',
            filterWord: 'GET_BIZ_LEDGER_MGT_FILTER_WORD',
            bizAuth: 'GET_BIZ_AUTH',
            incomeTotal: 'GET_BIZ_LEDGER_MGT_INCOME_TOTAL',
            expenseTotal: 'GET_BIZ_LEDGER_MGT_EXPENSE_TOTAL',
            advancePaymentTotal: 'GET_BIZ_LEDGER_MGT_ADVANCE_PAYMENT_TOTAL'
        })
    },
    components: {
        'dot-dropmenu': DotDropMenu,
        Modal,
        ledgerTipsHover,
        ledgerDetail,
        tableLoading
    }
}
</script>
<style lang="scss">
    .table-list.ledger-mgt-table{
        // .table-list-title .house:before{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     top: 2px;
        //     border-style: solid;
        //     border-width: 0 2.5px 4px 2.5px;
        //     border-color: transparent transparent #525956 transparent;
        // }
        // .table-list-title .house:after{
        //     content: '';
        //     position: absolute;
        //     width: 0;
        //     height: 0;
        //     left: 66px;
        //     bottom: 1px;
        //     border-style: solid;
        //     border-width: 4px 2.5px 0 2.5px;
        //     border-color: #525956 transparent transparent transparent;
        // }
        
        #modal.delete-bill{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #676362;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .table-list-title .date,
        .table-list-body ul li .date{
            width: 80px;
            margin-right: 43px;
        }
        .table-list-title .house-wrap,
        .table-list-body ul li .house-wrap{
            position: relative;
            display: flex;
            align-items: center;
            width: 220px;
            margin-right: 52px;
            .house-group{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                font-size: 12px;
                border-radius: 4px;
                background-color: #676362;
                margin-right: 4px;
                color: #ffffff;
            }
        }
        .table-list-title .income,
        .table-list-body ul li .income{
            width: 64px;
            margin-right: 60px;
        }
        .table-list-body ul li .income.body{
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
        }
        .table-list-body ul li .income.blue{
            background-color: rgba(113, 170, 229, 0.1);
            color: #71aae5;
        }
        .table-list-body ul li .income.red{
            background-color: rgba(255, 146, 117, 0.1);
            color: #fc7171;
        }
        .table-list-body ul li .income.gray{
            background-color: #f3f3f3;
            color: #676362;
        }
        .table-list-title .source,
        .table-list-body ul li .source{
            width: 76px;
            margin-right: 40px;
        }
        .table-list-title .note,
        .table-list-body ul li .note{
            width: 120px;
            margin-right: 60px;
        }
        .table-list-title .agent,
        .table-list-body ul li .agent{
            width: 42px;
            margin-right: 60px;
        }
        .table-list-title >.amount,
        .table-list-body ul li >.amount{
            position: relative;
            text-align: right;
            width: 80px;
            margin-right: 53px;
        }
    }
    // @media screen and (max-width: 1280px){
    //     .table-list.ledger-mgt-table{
    //         .table-list-title .house,
    //         .table-list-body ul li .house{
    //             margin-right: 48px;
    //         }
    //         .table-list-title .tanant,
    //         .table-list-body ul li .tanant{
    //             margin-right: 54px;
    //         }
    //         .table-list-title .phone,
    //         .table-list-body ul li .phone{
    //             margin-right: 64px;
    //         }
    //         .table-list-title .address,
    //         .table-list-body ul li .address{
    //             margin-right: 44px;
            
    //         }
    //         .table-list-title .rent,
    //         .table-list-body ul li .rent{
    //             margin-right: 32px;
    //         }
    //         .table-list-title .leave-date,
    //         .table-list-body ul li .leave-date{
    //             margin-right: 70px;
    //         }
    //     }
    
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/ledgerMgt/ledgerMgt.vue